
import React from 'react';
import PropTypes from 'prop-types';
import { graphql, gql, compose } from 'react-apollo';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import Loader from '../../../components/Loader';
import SocialMediaSettingsForm from '../../../components/siteadmin/SocialMediaSettingsForm/SocialMediaSettingsForm';
import s from '../../../components/siteadmin/SiteSettingsForm/SiteSettingsForm.css'; // Reusing existing styles for consistency

class SocialMedia extends React.Component {

    static propTypes = {
        title: PropTypes.string.isRequired,
        data: PropTypes.shape({
            loading: PropTypes.bool,
            siteSettings: PropTypes.array,
            getSocialInfo: PropTypes.object
        })
    };

    static defaultProps = {
        data: {
            loading: true,
            getSocialInfo: { channels: [], logs: [] }
        }
    };

    render() {
        const { data: { loading, siteSettings, getSocialInfo }, title } = this.props;
        let settingsCollection = {};

        if (!loading && siteSettings) {
            siteSettings.map((item) => {
                settingsCollection[item.name] = item.value;
            });
        }

        if (loading) {
            return <Loader type={"text"} />;
        } else {
            return <SocialMediaSettingsForm
                initialValues={settingsCollection}
                title={title}
                socialInfo={getSocialInfo || { channels: [], logs: [] }}
            />
        }
    }
}

export default compose(
    withStyles(s),
    graphql(gql`
        {
          siteSettings(type: "siteSettings") {
            name
            value
          }
          getSocialInfo {
            channels {
              id
              provider
              name
              picture
            }
            logs {
              timestamp
              type
              message
            }
          }
        }
      `,
        {
            options: (props) => ({
                fetchPolicy: 'network-only' // Always fetch fresh data
            })
        }
    ),
)(SocialMedia);
